import EditRoom from './EditRoom';
import { connect } from 'react-redux';
import { updateEditKeys } from '../../actions/question';
import { editRoom, resetEditRoom } from '../../actions/room';
import { clearAnswerKey } from '../../actions/question';
import { AppState } from '../../interfaces';

const mapStateToProps = (state: AppState) => ({
  listLocation: state.listLocationReducer,
  room: state.roomReducer,
});

const mapDispatchToProps = (dispatch) => ({
  editRoom: (id, room, roomName, data) =>
    dispatch(editRoom(id, room, roomName, data)),
  clearAnswerKey: () => dispatch(clearAnswerKey()),
  resetEditRoom: () => dispatch(resetEditRoom()),
  updateEditKeys: (data) => dispatch(updateEditKeys(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditRoom);
